export const solicitudesKeys = {
  all: ['solicitudes'] as const,
  lists: () => [...solicitudesKeys.all, 'list'] as const,
  list: (filters: Record<string, unknown>) => [...solicitudesKeys.lists(), filters] as const,
};
